import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Marker: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2194 5.73442C14.5225 4.12286 17.2302 3.2627 20.0001 3.2627C22.77 3.2627 25.4777 4.12286 27.7808 5.73442C30.0839 7.34598 31.879 9.63656 32.939 12.3165C33.999 14.9964 34.2764 17.9454 33.7361 20.7904C33.1958 23.6354 31.862 26.2488 29.9034 28.3L23.1508 35.3717C22.3152 36.2458 21.182 36.7373 20.0009 36.7373C18.8199 36.7373 17.6871 36.2463 16.8516 35.3722L10.097 28.3001C8.13841 26.2489 6.8045 23.6354 6.26417 20.7904C5.72385 17.9454 6.00123 14.9964 7.06126 12.3165C8.12129 9.63656 9.91635 7.34598 12.2194 5.73442ZM15.7238 13.4505C16.858 12.2628 18.3962 11.5955 20.0001 11.5955C21.6041 11.5955 23.1423 12.2628 24.2764 13.4505C25.4106 14.6383 26.0477 16.2492 26.0477 17.9289C26.0477 19.6086 25.4106 21.2195 24.2764 22.4072C23.1423 23.5949 21.6041 24.2622 20.0001 24.2622C18.3962 24.2622 16.858 23.5949 15.7238 22.4072C14.5897 21.2195 13.9525 19.6086 13.9525 17.9289C13.9525 16.2492 14.5897 14.6383 15.7238 13.4505ZM20.0001 14.2622C19.0715 14.2622 18.181 14.6485 17.5244 15.3362C16.8678 16.0238 16.4989 16.9564 16.4989 17.9289C16.4989 18.9013 16.8678 19.834 17.5244 20.5216C18.181 21.2092 19.0715 21.5955 20.0001 21.5955C20.9287 21.5955 21.8193 21.2092 22.4759 20.5216C23.1325 19.834 23.5014 18.9013 23.5014 17.9289C23.5014 16.9564 23.1325 16.0238 22.4759 15.3362C21.8193 14.6485 20.9287 14.2622 20.0001 14.2622Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Marker;
